<main class="landing">
  <section class="hero-shell">
    <div class="hero-left">
      <span class="hero-pill">Java Stream API Studio</span>
      <h1>Master Java Streams with a LeetCode-grade practice workflow.</h1>
      <p>
        javaStreams curates 500+ Stream API challenges with editorials, discussions, and a
        production-style Java workspace so you can level up fast.
      </p>
      <div class="hero-actions">
        <a routerLink="/auth" class="btn-primary">Start practicing</a>
        <a routerLink="/problems" class="btn-secondary">Browse problems</a>
      </div>

      <div class="hero-tags">
        <span>filter()</span>
        <span>map()</span>
        <span>reduce()</span>
        <span>collect()</span>
      </div>

      <div class="hero-metrics">
        <div>
          <strong>500+</strong>
          <span>Stream challenges</span>
        </div>
        <div>
          <strong>10</strong>
          <span>Problems per page</span>
        </div>
        <div>
          <strong>Daily</strong>
          <span>Practice streaks</span>
        </div>
      </div>
    </div>

    <div class="hero-right">
      <div class="hero-terminal ide-shell">
        <div class="terminal-bar">
          <span class="dot red"></span>
          <span class="dot amber"></span>
          <span class="dot green"></span>
          <span class="terminal-title">StreamPipeline.java</span>
        </div>
        <div class="terminal-tabs">
          <span class="active">StreamPipeline.java</span>
          <span>Tests</span>
          <span>Output</span>
        </div>
        <ol class="code-lines code-font">
          <li>List&lt;Integer&gt; evens = numbers.stream()</li>
          <li>  .filter(n -&gt; n % 2 == 0)</li>
          <li>  .map(n -&gt; n * 2)</li>
          <li>  .sorted()</li>
          <li>  .collect(Collectors.toList());</li>
          <li class="blank"></li>
          <li>System.out.println(evens);</li>
        </ol>
        <div class="terminal-footer">
          <span class="status ok">Build OK</span>
          <span>Java 17</span>
          <span>Runtime 12 ms</span>
          <span>Memory 36 MB</span>
        </div>
      </div>

      <div class="hero-card accent">
        <h3>Learning Tracks</h3>
        <ul>
          <li><strong>Beginner</strong> · filter, map, collect</li>
          <li><strong>Intermediate</strong> · reduce, groupingBy, partitioningBy</li>
          <li><strong>Advanced</strong> · flatMap, Optional, custom collectors</li>
          <li><strong>Expert</strong> · parallel streams, optimization</li>
        </ul>
      </div>
    </div>
  </section>

  <section class="feature-grid">
    <article class="feature-card">
      <h4>Production-ready patterns</h4>
      <p>Practice real stream pipelines: filtering, grouping, mapping, and collectors.</p>
    </article>
    <article class="feature-card">
      <h4>Instant feedback</h4>
      <p>Run sample tests or full submissions, track acceptance and execution time.</p>
    </article>
    <article class="feature-card">
      <h4>Progress insights</h4>
      <p>Stay on track with mastery dashboards, streaks, and recommended topics.</p>
    </article>
  </section>

  <section class="guide-grid">
    <header class="guide-header">
      <h2>Java Streams Guides</h2>
      <p>Short, focused guides that explain core Stream API topics.</p>
    </header>
    <div class="guide-cards">
      <a class="guide-card" routerLink="/java-streams">
        <h3>Streams Overview</h3>
        <p>Concepts, pipeline structure, and best practices.</p>
      </a>
      <a class="guide-card" routerLink="/java-streams-filter">
        <h3>filter Patterns</h3>
        <p>Predicate tips and practical filtering examples.</p>
      </a>
      <a class="guide-card" routerLink="/java-streams-map-vs-flatmap">
        <h3>map vs flatMap</h3>
        <p>When to transform and when to flatten.</p>
      </a>
      <a class="guide-card" routerLink="/java-streams-reduce">
        <h3>reduce Explained</h3>
        <p>Identity, accumulator, and safe reductions.</p>
      </a>
      <a class="guide-card" routerLink="/java-streams-collectors">
        <h3>Collectors</h3>
        <p>groupingBy, partitioningBy, and summaries.</p>
      </a>
    </div>
  </section>
</main>
